var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmplifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.3,
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.345 2.15l-.238.004a7.194 7.194 0 104.616 12.898l.245-.197.202.009 2.839 2.838.036.033a.49.49 0 00.723-.647l-.061-.074-2.843-2.844-.009-.202A7.195 7.195 0 009.822 2.166l-.238-.012-.239-.004zm0 .98a6.214 6.214 0 11-.001 12.427 6.214 6.214 0 010-12.427z",
    stroke: "#191C26",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16 10.79a.49.49 0 00-.45.685l.043.078-.002.005.065.097c.856 1.261 2.119 2.026 3.589 2.17l.261.018.101.002v-.98l-.204-.01a3.822 3.822 0 01-2.71-1.445l-.144-.188-.136-.199-.018-.033a.49.49 0 00-.215-.166l-.088-.025-.092-.009z",
    stroke: "#3B65EE",
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifier);
export default __webpack_public_path__ + "static/assets/amplifier.8c0321a7.svg";
export { ForwardRef as ReactComponent };